export const settingsRoutes = {
  default: 'agency_profile_settings-v2',
  location: 'settings-v2',
  profile: 'agency_profile_settings',
  audit: 'audit',
  labs: 'agency-labs',
  company: 'agency_company_settings',
  team: 'account_team_management',
  billing: 'account_billing',
  snapshot: {
    default: 'snapshot_settings',
    importAccountTemplate: 'import_account_template',
    list: 'snapshot',
  },
  phoneIntegration: 'phone_integration',
  sendGrid: 'sendgrid_settings',
  emailService: 'email_services_settings',
  dedicatedDomains: 'agency-dedicated-domains',
  addDedicatedDomains: 'agency-add-dedicated-domain',
  verifyDedicatedDomains: 'agency-verify-dedicated-domain',
  blacklistMonitorReports: 'agency-blacklist-monitor-reports',
  opmTrafficStats: 'agency-opm-traffic-stats',
  gpmTrafficStats: 'agency-gpm-traffic-stats',
  affiliate: 'affiliate_settings',
  customMenuLink: 'custom_menu_link_settings',
  stripe: 'stripe_settings',
  // stripeV2: 'stripe_settings_v2',
  whiteLabel: 'whitelabel_settings',
  apiKey: 'api_key',
  compliance: {
    default: 'compliance',
    hipaaDocument: 'hipaa-document',
    hipaaDetail: 'hipaa-detail',
  },
  launchpad: 'launchpad_settings',
  locationSmtpSettings: 'agency-smtp-settings',
  customObjects: {
    default: 'custom-objects-list',
    create: 'custom-objects-create',
    details: 'custom-object-details',
    associations: 'custom-object-associations',
    customizeRecordModal: 'customize-record-modal',
  },
  privateIntegrations: {
    default: 'private-integrations-company',
    list: 'sub-app-private-integration-company-list',
    subapp: 'sub-app-private-integration-company',
    edit: 'sub-app-private-integration-company-edit',
  },
  defaultEmails: {
    default: 'default-emails',
  },
  askAIConfiguration: 'ask-ai-configuration',
  announcements: {
    default: 'announcements-list',
  },
  mediaStorageUsage: 'media-storage-usage',
}
